<template>
  <div class="criteria-container">
    <div v-if="!saved" class="row">
      <div class="col-12">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            id="comment"
            v-model="criteria"
            class="criteria-container__text-area"
            :count-classes="['d-block', 'small-counter']"
            custom-error-msg="Favor escribir una descripción de criterios y procedimientos"
            :error="errors[0]"
            label="Describa los criterios y procedimientos que se utilizarán para evaluar el progreso del estudiante: "
            :maxlength="3000"
            name="comment"
            show-char-count
          />
        </validation-provider>
      </div>
      <div class="col-12 mt-3 mt-md-2 d-flex justify-content-end">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="cancel"
        />

        <action-button
          i="fa fa-save"
          text="Guardar"
          variant="success"
          @click="saveCriteria"
        />
      </div>
    </div>
    <div v-else class="row align-items-center">
      <div class="col-12 col-md-10">
        <label class="input-display d-block">
          Describa los criterios y procedimientos que se utilizarán para evaluar
          el progreso del estudiante:
        </label>
        <span class="text-format">{{ data }}</span>
      </div>
      <div v-if="!readOnly" class="col-12 col-md-2 text-right">
        <drop-down class="criterias-action" :items="actionItems" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';

export default {
  name: 'InterventionPlanCriterias',
  components: {
    CustomTextArea,
    ActionButton,
    DropDown,
  },
  props: {
    data: {
      type: String,
      default: () => '',
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    criteria: '',
    saved: false,
  }),
  computed: {
    actionItems() {
      return [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          border: 'bottom',
          click: () => this.editCriteria(),
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-primary-3',
          click: () => this.deleteCriteria(),
        },
      ];
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(current) {
        this.criteria = current;
        this.saved = this.criteria.length != 0;
      },
    },
  },
  methods: {
    saveCriteria() {
      this.$emit('save-criteria', this.criteria);
    },
    editCriteria() {
      this.saved = false;
    },
    deleteCriteria() {
      this.$emit('delete-criteria');
    },
    cancel() {
      if (this.data?.length) {
        this.saved = true;
        this.criteria = this.data;
        return;
      }
      this.criteria = null;
      this.$emit('cancel-criteria');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.criteria-container {
  padding: 0 0.8rem;
  ::v-deep &__text-area {
    .small-counter {
      font-size: 0.8rem;
      color: map-get($colors, 'gray-6');
    }
  }

  .input-display {
    font-size: 0.875rem;
    color: map-get($colors, 'gray-6');
    font-weight: bold;
  }

  .text-format {
    overflow-wrap: break-word;
    text-align: justify;
  }

  @media only screen and (max-width: 768px) {
    ::v-deep .criterias-action {
      .btn {
        margin-top: 0.8rem;
        width: 100%;
      }
    }
  }
}
</style>
